import {Injectable} from '@angular/core';
import {firstValueFrom, take} from 'rxjs';
import {Store} from '@ngrx/store';
import {UserAppState} from '../../store/user/reducers/user.reducer';
import {selectUser} from '../../store/user/selectors/user.selectors';
import {environment} from '../../../environments/environment';
import {UserService} from '../user/user.service';
import {User} from '../../model/user';


@Injectable({providedIn: 'root'})
export class SkendataService {

  constructor(private readonly userStore: Store<UserAppState>,
              readonly userService: UserService) {}

  // SHA-512 helper function
  async sha512(message: string): Promise<string> {
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-512', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
  }

  getCurrentEnvironment() : string {
    const windowUrl = window.location.hostname;
    let currentEnvironment = "";
    if (windowUrl.includes("dev"))
      currentEnvironment = "dev";
    else if (windowUrl.includes("int"))
      currentEnvironment = "int";
    else if (windowUrl.includes("sit"))
      currentEnvironment = "sit";
    else if (windowUrl.includes("uat"))
      currentEnvironment = "uat";
    else
      currentEnvironment = "prod";

    return currentEnvironment;
  }

  async submitModule1() {
    let user = await firstValueFrom(this.userStore.select(selectUser).pipe(take(1)));

    const secretKey = environment.skenDataSecretKey;

    const currentEnvironment = this.getCurrentEnvironment();

    const formFields: { [key: string]: string } = {
      module: '1',
      apiKey: environment.skenDataApiKey,
      signatureHash: '', // to be computed below
      accountName: currentEnvironment + "_" + user.id,
      lastName: user.lastName || '',
      firstName: user.firstName || '',
      sex: '',
      email: user.email || '',
      customerId: user.id || '',
      company: user.company?.name || '',
      location: user.company?.location || '',
      street: user.company?.street || '',
      houseNo: user.company?.houseNumber || '',
      zipCode: user.company?.postalCode || '',
      telNo: user.telephoneNumber || '',
      nationKey: user.countryCode || '',
    };

    // Build the hash input string
    const hashInput = [
      formFields.accountName,
      formFields.lastName,
      formFields.firstName,
      formFields.email,
      formFields.company,
      formFields.zipCode,
      secretKey,
    ].join('');

    const hash = await this.sha512(hashInput);
    formFields.signatureHash = hash;

    // Create and submit form
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = 'https://www.wert14.de/_reseller_';
    form.target = '_blank';


    for (const [key, value] of Object.entries(formFields)) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);

    // save SkenData credentials in user object that it registered with SkenData
    let userNew = new User();
    userNew.skenDataAccountId = currentEnvironment + "_" + user.id;
    this.userService.updateUserSkenDataCredentials(user.id, userNew).subscribe();
  }

  async submitModule2(inquiryHouseNo?: string, inquiryZipCode?: string, inquiryStreet?: string, inquiryLocation?: string) {
    let user = await firstValueFrom(this.userStore.select(selectUser).pipe(take(1)));

    const secretKey = environment.skenDataSecretKey;

    const currentEnvironment = this.getCurrentEnvironment();

    const formFields: { [key: string]: string } = {
      module: '2',
      apiKey: environment.skenDataApiKey,
      signatureHash: '', // to be computed below
      accountName: currentEnvironment + "_" + user.id,
      lastName: user.lastName || '',
      firstName: user.firstName || '',
      sex: '',
      email: user.email || '',
      customerId: user.id || '',
      company: user.company?.name || '',
      location: user.company?.location || '',
      street: user.company?.street || '',
      houseNo: user.company?.houseNumber || '',
      zipCode: user.company?.postalCode || '',
      telNo: user.telephoneNumber || '',
      nationKey: user.countryCode || '',
      inquiryHouseNo: inquiryHouseNo || '',
      inquiryZipCode: inquiryZipCode || '',
      inquiryStreet: inquiryStreet ||'',
      inquiryLocation: inquiryLocation || '',
    };

    // Build the hash input string
    const hashInput = [
      formFields.accountName,
      formFields.lastName,
      formFields.firstName,
      formFields.email,
      formFields.company,
      formFields.zipCode,
      secretKey,
    ].join('');

    const hash = await this.sha512(hashInput);
    formFields.signatureHash = hash;

    // Create and submit form
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = 'https://www.wert14.de/_reseller_';
    form.target = '_blank';


    for (const [key, value] of Object.entries(formFields)) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);

    // save SkenData credentials in user object that it registered with SkenData
    let userNew = new User();
    userNew.skenDataAccountId = currentEnvironment + "_" + user.id;
    this.userService.updateUserSkenDataCredentials(user.id, userNew).subscribe();
  }

}
